import { useNavigate } from "react-router";

import { Image } from "@components/Image";
import { Stack } from "@components/Stack";
import { Typography } from "@components/Typography";

import { useLayoutBreakpoint } from "@hooks/useLayoutBreakpoint";

import { useBalanceQuery } from "@storage/queries/tokens-information/useBalanceQuery";
import { useTokensPast12hQuery } from "@storage/queries/tokens-information/useTokensPast12hQuery";

import { SKELETON_BLOCK_CLASS } from "@configs/constants";
import { ICON_PATHS } from "@configs/icons";
import { ROUTES } from "@configs/routes";

export const UserBalance = () => {
	const navigate = useNavigate();
	const { MAX_DESKTOP, DESKTOP } = useLayoutBreakpoint();
	const modelBalanceQuery = useBalanceQuery();
	const tokensPast12hQuery = useTokensPast12hQuery();

	const balanceTextAvailable = MAX_DESKTOP || DESKTOP;

	const handleGoBalance = () => {
		navigate(ROUTES.EARNINGS);
	};

	return (
		<div
			className="mr-3 cursor-pointer rounded-lg outline-none hover:bg-grey-hover desktop:mr-0 desktop:py-1 desktop:pr-3"
			onClick={() => handleGoBalance()}
		>
			<Stack direction="row" spacing={6} align="center">
				<Image width={32} height={32} src={ICON_PATHS.BALANCE} alt="icon_balance" />
				{balanceTextAvailable ? (
					<Stack>
						<Stack spacing={4} direction="row" align="center">
							{tokensPast12hQuery.isLoading ? (
								<Stack direction="row" spacing={2} align="center" aria-busy="true">
									<span className={`${SKELETON_BLOCK_CLASS} inline-block h-3.5 w-12`} />
									<Typography type="span" padding="none" size="sm" weight="bold">
										tk
									</Typography>
								</Stack>
							) : (
								<Typography type="span" padding="none" size="sm" weight="bold">
									{tokensPast12hQuery.isSuccess ? tokensPast12hQuery.data.toLocaleString("ru") : "0"} tk
								</Typography>
							)}
							<Typography type="span" className="text-[13px]" padding="none" color="msg_time">
								/
							</Typography>
							<Typography type="span" className="text-[13px]" padding="none" color="msg_time">
								12h
							</Typography>
						</Stack>
						<Stack direction="row" spacing={4} align="center">
							<Typography type="span" padding="none" size="xs">
								Balance:
							</Typography>
							{modelBalanceQuery.isLoading ? (
								<span className={`${SKELETON_BLOCK_CLASS} inline-block h-3 w-12`} aria-busy="true" />
							) : (
								<Typography type="span" padding="none" size="xs">
									{modelBalanceQuery.isSuccess ? modelBalanceQuery.data.toLocaleString("ru") : "0"}
								</Typography>
							)}
							<Typography type="span" padding="none" size="xs">
								tk
							</Typography>
						</Stack>
					</Stack>
				) : null}
			</Stack>
		</div>
	);
};
